export default __webpack_public_path__ + "static/media/impact-score-update.b55f504a.png";